import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../../../src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PucaCitizenInformationService {

	constructor(public http: HttpClient) { }

	public getCountriesList(): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getCountryList')
	}

	public getUSCitizenshipList(): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getCountryList')
	}
	public getUSVisaTypeList(): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getCountryList')
	}

	public getApplicationFormData(applicationId, profileId): Observable<any> {
		return this.http.get(`${environment.BASE_URL_HRD_PUCA}puca/getApplicationFormData/${applicationId}/${profileId}`)
	}

	public saveApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'puca/saveApplication', payload)
	}
}
